export class HttpError {
  public readonly statusCode: number;
  public readonly errorMessages: string[];
  public readonly api: string;

  constructor(statusCode: number, errorCodes: string[], api: string) {
    this.statusCode = statusCode;
    this.errorMessages = errorCodes;
    this.api = api;
  }
}
export class GenericError extends HttpError {}

export class MissingParameterError extends HttpError {}
export class UnauthorizedError extends HttpError {}
export class NotFoundError extends HttpError {}
export class InternalServerError extends HttpError {}
